import { ReactComponent as FlagIcon } from "./svg/nz-flag.svg";
import "../flag-icon.scss";

export const NZFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
